import {
  LazyModalLogoutTokenExpired,
  LazyModalUserIdle,
  LazyModalLogin,
  LazyModalLoginError,
} from "#components";

export const useAuthModalsStore = defineStore("AuthModals", () => {
  const userStore = useUserStore();
  const route = useRoute();
  const { openModal, closeModal } = useModalManager();
  const { sessionTimeout } = useRuntimeConfig().public;
  const { idle } = useIdle(sessionTimeout * 60 * 1000);
  const isFocused = useWindowFocus();

  watch(isFocused, (focused) => {
    if (focused && userStore.isExpired) {
      closeModal("modal-user-idle");
      openModal({
        id: "modal-logout-token-expired",
        component: LazyModalLogoutTokenExpired,
      });
    }
  });

  onMounted(() => {
    watch(
      () => route.query.cause,
      (cause) => {
        if (cause === "authExpired" || cause === "expired") {
          openModal({
            id: "modal-logout-token-expired",
            component: LazyModalLogoutTokenExpired,
          });
        }
      },
      { immediate: true }
    );

    watch(idle, (idleValue) => {
      if (idleValue) {
        if (userStore.isLoggedIn)
          openModal({
            id: "modal-user-idle",
            component: LazyModalUserIdle,
          });
      }
    });

    if (route.query.cause === "auth" && !userStore.isLoggedIn)
      openModal({
        id: "modal-login",
        component: LazyModalLogin,
      });

    watch(
      () => route.query.cause === "error",
      (error) => {
        if (error)
          openModal({
            id: "modal-login-error",
            component: LazyModalLoginError,
          });
      },
      { immediate: true }
    );
  });
  return {};
});
